<template>
    <div align="left">
      <v-btn v-if="!disabled" tile color="success" @click="addNewExtranote()" >
          <v-icon left>mdi-plus</v-icon>เพิ่มช่องใส่ข้อมูลนัดเพิ่มเติม
      </v-btn>

        <v-simple-table fixed-header align="left" >
            <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">รหัส</th>
                <th class="text-left">ชื่อ</th>
                <th class="text-left">รายละเอียด</th>
                <th class="text-left"></th>
                </tr>
            </thead>
            <tbody >
                <tr v-for="(item,i) in extranote_list" :key="item.extranote_name"> 
                    <td class="pt-4">
                        <v-text-field
                            v-model="item.extranote_name"
                            @change="formChange"
                            outlined
                            dense
                            :disabled="disabled"
                        ></v-text-field>
                    </td>
                    <td class="pt-4">
                        <v-text-field
                            v-model="item.extranote_label"
                            @change="formChange"
                            outlined
                            dense
                            :disabled="disabled"
                        ></v-text-field>
                    </td>
                    <td class="pt-4">
                        <v-text-field
                            v-model="item.extranote_value"
                            @change="formChange"
                            outlined
                            dense
                            :disabled="disabled"
                        ></v-text-field>
                    </td>
                    <td>
                        <v-btn v-if="!disabled" tile icon @click="delExtranote(i)">
                            <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
            </template>
        </v-simple-table>
    </div>
</template>
<script>
  export default {
    props: ['extranote_list','onchange','disabled'],
    data () {
        return {

        }
    },methods : {
      addNewExtranote : function() {
        var extranote_name = "note"
        var i = 1
        while(this.extranote_list.filter(e=>e.extranote_name == extranote_name + i).length > 0) {
          i = i + 1
        }
        extranote_name = extranote_name + i
        this.extranote_list.push({
          extranote_name : extranote_name
          ,extranote_label : ""
          ,extranote_value : ""
        })
        this.formChange()
      },
      delExtranote(index){
        this.extranote_list.splice(index,1)
        this.formChange()
      },
      formChange(){
        this.onchange('extranote_list',this.extranote_list)
      }
    }
  }
</script>